<template>
  <div
    class="fixed left-10 md:left-20 py-4 pl-25 bg-primary text-app-color w-284 max-w-full mx-auto text-center rounded-6 z-9999 shadow-notify"
    :style="`bottom: ${index * 70 + 20}px`"
  >
    <div class="flex justify-between items-center">
      <p class="py-10">{{ type }} deleted</p>
      <div class="flex items-center cursor-pointer">
        <ButtonModule
          text="Undo"
          class="px-15 py-10 rounded-6 bg-primary text-link-color border-1/5 border-link-color hover:bg-link-color hover:text-white text-16"
          @click="restore"
        />
        <i class="icon-close p-18 text-app-color text-14" @click="close" />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default {
  components: { ButtonModule },

  props: {
    type: { type: String },
    index: { type: Number }
  },

  emits: ['close', 'restore'],

  created () {
    setTimeout(() => { this.close() }, 10000)
  },

  methods: {
    close () {
      this.$emit('close')
    },

    restore () {
      this.$emit('restore')
      this.close()
    }
  }
}
</script>
